import Vue from "vue";
import axios from 'axios';
import * as Sentry from "@sentry/vue";
import {
  CONTENT_REQUEST, CONTENT_SUCCESS, CONTENT_ERROR,
  SET_PRIVACY_DATA, PRIVACY_REQUEST,
  SET_NOTIFICATION, API_URL,
  SET_EULA_DATA, EULA_REQUEST,
} from "@/store/constant";

const state = { status: null, privacy: null, eula: null, };

const getters = {
  privacy: state => state.privacy,
  contentStatus: state => state.status,
  eula: state => state.eula,
};

const actions = {
  [PRIVACY_REQUEST]: (({commit}) => {
    commit(CONTENT_REQUEST);
    commit(SET_NOTIFICATION,{ type: null });
    return new Promise((resolve, reject) => {
      axios({ url: `${API_URL}/privacy-policy` })
        .then(resp => {
          commit(CONTENT_SUCCESS);
          commit(SET_PRIVACY_DATA, resp.data);
          resolve(resp);
        })
        .catch(err => {
          commit(CONTENT_ERROR, err);
          commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages });
          reject(err);
          Sentry.captureException(err);
        })
    });
  }),
  [EULA_REQUEST]: (({commit}) => {
    commit(CONTENT_REQUEST);
    commit(SET_NOTIFICATION,{ type: null });
    return new Promise((resolve, reject) => {
      axios({ url: `${API_URL}/eula` })
        .then(resp => {
          commit(CONTENT_SUCCESS);
          commit(SET_EULA_DATA, resp.data);
          resolve(resp);
        })
        .catch(err => {
          commit(CONTENT_ERROR, err);
          commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages });
          reject(err);
          Sentry.captureException(err);
        })
    });
  })
}

const mutations = {
  [CONTENT_REQUEST]: state => {
    state.status = 'loading';
  },
  [CONTENT_SUCCESS]: (state) => {
    state.status = 'success';
  },
  [SET_PRIVACY_DATA]: (state, payload) => {
    Vue.set(state, "privacy", payload);
  },
  [CONTENT_ERROR]: state => {
    state.status = 'error';
  },
  [SET_EULA_DATA]: (state, payload) => {
    Vue.set(state, "eula", payload);
  },
  [SET_NOTIFICATION]: (state, payload) => {
    state.notification = { type: null, messages: [] };
    if(payload.type) {
      state.notification = payload;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
